export default __webpack_public_path__ + "static/media/Google.302b9032.svg";